export const downloadBlob = (file: Blob, filename: string) => {
  const url = globalThis.URL.createObjectURL(file)
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
}
